'use strict';
import { PartyData } from '../../js/gamedata/partydata';

ui.loadTemplateFile('party.html');

class PartyDialog extends Dialog {
  _element: any;
  _titleBar: any;
  _level: any;
  _xp: any;
  _members: any;
  _leaveButton: any;
  _memberList: any[];
  _data: any;

  constructor(party: any) {
    super('party.html');

    this._level = ui.label(this, '.label.level');
    this._xp = ui.progressbar(this, '.progressbar.exp');
    this._members = ui.list(this, '.list.members');
    this._leaveButton = ui.button(this, '.button.leave');
    this._leaveButton.on('clicked', () => netGame.leaveParty());
    this._memberList = [];

    this.centerY();
    this.alignRightEdge(50);

    this._data = party;
    this._data.on('changed', this._update.bind(this));
    this._update();
  }

  _update() {
    if (!this._data.exists) {
      this.hide();
      return;
    }

    this.show();

    this._level.text('Level: ' + this._data.level);
    this._xp.max(PartyData.getLevelMaxXP(this._data.level));
    this._xp.value(this._data.xp);

    if (this._members.length !== this._data.members.length) {
      this._members.clear();
      this._memberList = [];

      for (let i = 0; i < this._data.members.length; ++i) {
        const partyMember = ui.partymember();
        this._memberList.push(partyMember);
        this._members.append(partyMember);
      }
    }

    for (let i = 0; i < this._data.members.length; ++i) {
      this._memberList[i].setMember(this._data.members[i]);
    }

    this.centerY();
    this.alignRightEdge(50);
  }
}

ui.PartyDialog = PartyDialog;

class PartyMember extends Widget {
  _element: any;
  _name: any;
  _hp: any;
  _member: any;

  constructor(element: any) {
    super(element);

    this._name = ui.label(this, '.label.name');
    this._hp = ui.progressbar(this, '.progressbar.health');

    this._member = null;
    this._update();
  }

  setMember(member: any) {
    this._member = member;
    this._update();
  }

  _update() {
    if (!this._member) {
      return;
    }

    this._name.text(this._member.name);
    this._hp.max(this._member.maxHP);
    this._hp.value(this._member.hp);
  }

  static Create() {
    let html = '<div class="partymember">';
    html += '<div class="label name flex-fill" />';
    html += '<div class="progressbar health absolute" />';
    html += '</div>';
    return $(html);
  }
}

ui.PartyMember = PartyMember;

ui.partymember = ui.widgetConstructor('partymember', ui.PartyMember);

ui.partyDialog = (party: any) => {
  return new ui.PartyDialog(party);
};
